import React, { useContext, useEffect, useState, useCallback } from "react";
import { useSnackbar } from "../Utility/UserMessageContext";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Fab,
  Grid2,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AuthContext from "../Context/AuthProvider";
import { Person } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NotesIcon from "@mui/icons-material/Notes";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaidIcon from "@mui/icons-material/Paid";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import UndoIcon from "@mui/icons-material/Undo"; // import LocalHospitalIcon from '@mui/icons-material/PersonAdd';

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { Link } from "react-router-dom";

import DnsIcon from "@mui/icons-material/Dns";
import dayjs from "dayjs";
import {
  CloseOutlined,
  DeleteOutlineRounded,
  DisabledByDefault,
  EditOutlined,
  EventNoteOutlined,
  PostAdd,
} from "@mui/icons-material";
import { formatAge } from "../Utility/Utility";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import { Cake, Wc, Phone, Email, Badge } from "@mui/icons-material";
import { Modal, Toast } from "bootstrap";
import { getDisplayValue, showLoadingImage } from "../Utility/Utility";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import {
  compareDates,
  convertUTCToTimeZone,
  convertUTCToTimeZoneDateTimeString,
} from "../Utility/DateTimeUtility";
import { getPlanById } from "../API/PlansApi";
import { getBillByPlanId } from "../API/BillingApi";
import MenuBar from "../common/MenuBar";

const PlanDetails = ({
  key,
  selectedPlan,
  onViewPatientDetails,
  onViewVisitDetails,
  onEditBill,
  onEditPlan,
}) => {
  const { auth } = useContext(AuthContext);
  const [showSpinner, setShowSpinner] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const showLoading = isLoading || showSpinner;
  const { showSnackbar } = useSnackbar();

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [billDetails, setBillDetails] = useState(null);
  const [linkedServices, setLinkedServices] = useState();
  const [planData, setplanData] = useState({});
  const [pageSize, setPageSize] = useState(20);

  const [billAmountSummary, setBillAmountSummary] = useState({
    totalAmount: 0,
    paidAmount: 0,
    refundedAmount: 0,
    balanceAmount: 0,
  });
  // Check if the screen is small (sm) or extra small (xs)
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  // const handleMenuClose = () => {
  //   setMenuAnchor(null);
  //   setCurrentRow(null);
  // };

  useEffect(() => {
    const fetchData = async () => {
      setShowSpinner(true);

      try {
        const result = await getPlanById(auth, selectedPlan.id);
        if (result.isSuccess) {
          setplanData(result.data);
          const billResult = await getBillByPlanId(auth, selectedPlan.id);
          if (billResult.isSuccess) {
            setBillDetails(billResult.data);
          }
          // console.log('plandata',planData);
        }
      } catch (error) {
        console.error("Error loading plans:", error);
        showSnackbar(
          "An unexpected error occurred while loading plans.",
          "error",
        );
      } finally {
        setShowSpinner(false);
      }
    };

    fetchData();
  }, [selectedPlan.id]);

  // Render service cards for mobile view
  const renderServiceCards = () => {
    if (!linkedServices || linkedServices.length === 0) {
      return <Typography variant="body2">No services found</Typography>;
    }
  };

  // Render patient details card for mobile view
  const renderPatientDetailsCard = () => {
    return (
      <Card
        className="outerCard"
        variant="outlined"
        sx={{ mb: 2, borderRadius: 2, width: "100%" }}
      >
        <CardContent sx={{ padding: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Patient's Details
          </Typography>

          <Divider sx={{ my: 1 }} />

          {/* Patient details section - now takes full width */}
          <Box sx={{ width: "100%" }}>
            <Box sx={{ "& > div": { mb: 1 } }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Name:</Typography>
                <Typography variant="body2">
                  <span
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      onViewPatientDetails &&
                      onViewPatientDetails({
                        id: planData?.patientId,
                        firstName: planData?.visits?.[0]?.patientFirstName,
                        lastName: planData?.visits?.[0]?.patientLastName,
                      })
                    }
                  >
                    {planData?.visits?.[0]?.patientFirstName}&nbsp;
                    {planData?.visits?.[0]?.patientLastName}
                  </span>
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">MRN:</Typography>
                <Typography variant="body2">
                  {planData?.visits?.[0]?.patientMRN || "N/A"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Age:</Typography>
                <Typography variant="body2">
                  {formatAge(planData?.visits?.[0]?.patientAgeInYears)}{" "}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Gender:</Typography>
                <Typography variant="body2">
                  {planData?.visits?.[0]?.patientGender || "N/A"}{" "}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Mobile:</Typography>
                <Typography variant="body2" sx={{ overflowWrap: "break-word" }}>
                  {planData?.visits?.[0]?.patientMobileNo || "N/A"}{" "}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Email:</Typography>
                <Typography variant="body2" sx={{ overflowWrap: "break-word" }}>
                  {planData.patientEmailId || "-"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Photo section - moved below the details */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <img
              src={
                planData?.patient?.photo
                  ? planData?.patient?.photo
                  : planData?.visits?.[0]?.patientGender === "Male"
                    ? "./placeholder-image-male-gender.webp"
                    : "./placeholder-image-female-gender.webp"
              }
              className="border rounded p-0"
              alt="PatientPhoto"
              width="80"
              height="80"
            />
          </Box>
        </CardContent>
      </Card>
    );
  };

  // Render visit details card for mobile view
  const renderVisitDetailsCard = () => {
    return (
      <Card
        className="outerCard"
        variant="outlined"
        sx={{ mb: 2, borderRadius: 2, width: "100%" }}
      >
        <CardContent sx={{ padding: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Plan Details
          </Typography>

          <Divider sx={{ my: 1 }} />

          <Box sx={{ "& > div": { mb: 1 } }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Plan ID:</Typography>
              <Typography variant="body2">
                {planData.displayId || "-"}{" "}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Plan Name:</Typography>
              <Typography variant="body2">{planData.name || "-"} </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Visit Type:</Typography>
              <Typography variant="body2">
                {planData?.visits?.[0]?.currentVisitType}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Status:</Typography>
              <Typography variant="body2">{planData?.status}</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Referred By:</Typography>
              <Typography variant="body2">
                {planData?.visits?.[0]?.referredBy || "-"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">
                Scheduled At (Start Date):
              </Typography>
              <Typography variant="body2">{planData?.startDate}</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Booked By:</Typography>
              <Typography variant="body2">
                {planData.createdByUserName || "-"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Time of Booking:</Typography>
              <Typography variant="body2">
                {convertUTCToTimeZoneDateTimeString(
                  planData.createdOn,
                  auth?.selectedFacility?.timeZone,
                )}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Notes:</Typography>
              <Typography variant="body2">
                {planData.notes || "notes here..."}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

  // Render primary service card for mobile view
  const renderPrimaryServiceCard = () => {
    return (
      <Card
        className="outerCard"
        variant="outlined"
        sx={{ mb: 2, borderRadius: 2, width: "100%" }}
      >
        <CardContent sx={{ padding: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Primary Service Scheduled With
          </Typography>

          <Divider sx={{ my: 1 }} />

          <Box sx={{ "& > div": { mb: 1 } }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Physician's Name:</Typography>
              <Typography variant="body2">
                {`${planData?.physicianName || ""} `.trim()}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Physician's Email:</Typography>
              <Typography variant="body2">
                {planData.physicianEmail || "-"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Physician's Mobile :</Typography>
              <Typography variant="body2">
                {planData.physicianMobileNo || "-"}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

  // Render Bill info card for mobile view
  const renderBillInfoCard = () => {
    return (
      <Card
        className="outerCard"
        variant="outlined"
        sx={{ mb: 2, borderRadius: 2, width: "100%" }}
      >
        <CardContent sx={{ padding: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Bill Information
          </Typography>

          <Divider sx={{ my: 1 }} />

          {billDetails?.length === 0 ? (
            <Grid2 size={12}>
              <HeaderValueDisplay
                header="plan Status"
                value="No bill exists for this plan"
              />
            </Grid2>
          ) : (
            <>
              {" "}
              <Box sx={{ "& > div": { mb: 1 } }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Bill Id:</Typography>
                  <Typography variant="body2">
                    {billDetails?.displayId}{" "}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Total Billed Amount:</Typography>
                  <Typography variant="body2">
                    {`Rs ${(
                      billDetails?.totalAmount +
                      (parseFloat(billDetails?.advanceAmount) || 0)
                    ).toFixed(2)}`}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Total Paid Amount:</Typography>
                  <Typography variant="body2">
                    {`Rs ${billDetails?.paidAmount?.toFixed(2)}`}{" "}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">
                    Total Refunded Amount:
                  </Typography>
                  <Typography variant="body2">
                    {`Rs ${billDetails?.refundedAmount?.toFixed(2)}`}{" "}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Total Balance:</Typography>
                  <Typography variant="body2">
                    {`Rs ${billDetails?.balanceAmount?.toFixed(2)}`}{" "}
                  </Typography>
                </Box>
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    );
  };

  // Render All visits card for mobile view
  const renderAllVisitsCard = () => {
    return (
      <Grid2 container spacing={0.1}>
        <Typography>All Visits</Typography>
        {planData?.visits?.map((visit) => (
          <Grid2 key={visit.id} xs={12} margin={"5px 0px"}>
            <Card
              className="outerCard"
              variant="outlined"
              sx={{
                padding: "8px",
                pointerEvents: showLoading ? "none" : "auto",
                opacity: showLoading ? 0.6 : 1,
                width: "100%",
              }}
            >
              <Grid2 container spacing={0.5}>
                {/* displayId of visit */}
                <Grid2 size={12}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    <Badge fontSize="small" />
                    <Link>{visit.displayId}</Link>
                  </Box>
                </Grid2>

                {/* time and date */}
                <Grid2 size={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <CalendarMonthIcon fontSize="small" />
                    <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                      {convertUTCToTimeZoneDateTimeString(
                        visit.scheduledStartDateTime,
                        auth?.selectedFacility?.timeZone,
                      )}
                    </Typography>
                  </Box>
                </Grid2>

                {/* primary Service Name */}
                <Grid2 size={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <MedicalServicesIcon fontSize="small" />
                    <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                      {`${visit.primaryServiceName} (${visit.primaryServiceDurationInMins} mins)`}
                    </Typography>
                  </Box>
                </Grid2>

                {/* physician Name */}
                <Grid2 size={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Person fontSize="small" />
                    <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                      {`${visit.physicianFirstName} ${visit.physicianLastName}`}
                    </Typography>
                  </Box>
                </Grid2>

                {/* Status */}
                <Grid2 size={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <ScheduleIcon fontSize="small" />
                    <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                      {visit.visitStatus}
                    </Typography>
                  </Box>
                </Grid2>

                {/* total amount */}
                <Grid2 xs={1}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <CurrencyRupeeIcon fontSize="small" />
                    <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                      {visit.totalAmount || "0"}
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    );
  };

  const columns = [
    {
      field: "displayId",
      headerName: "Visit ID",
      width: 250,
      renderCell: (params) => {
        return (
          <span
            style={{
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => onViewVisitDetails && onViewVisitDetails(params.row)}
          >
            {params.row.displayId}
          </span>
        );
      },
    },
    {
      field: "scheduledStartDateTime",
      headerName: "Date & Time",
      width: 250,
      renderCell: (params) =>
        convertUTCToTimeZoneDateTimeString(
          params.row.scheduledStartDateTime,
          auth?.selectedFacility?.timeZone,
        ),
    },
    {
      field: "physicianFirstName",
      type: "text",
      headerName: "Physician Name",
      width: 200,
      renderCell: (params) => {
        const patientPrefix = params?.row?.physicianPrefix || "";

        const firstName = params?.row?.physicianFirstName || "";
        const lastName = params?.row?.physicianLastName || "";

        return `${patientPrefix} ${firstName} ${lastName}`.trim();
      },
    },
    {
      field: "primaryServiceName",
      headerName: "Primary Service Name",
      width: 250,
      renderCell: (params) => {
        const serviceName = params.row?.primaryServiceName;
        const duration = params.row?.primaryServiceDurationInMins;
        return `${serviceName} (${duration} min)`;
      },
    },

    {
      field: "visitStatus",
      headerName: "Status",
      width: 200,
      renderCell: (params) => getDisplayValue(params?.row?.visitStatus),
    },
    {
      field: "price",
      headerName: "Price",
      width: 200,
      renderCell: (params) => {
        const total = params?.row?.primaryServiceFees;
        const discount = params?.row?.primaryServiceDiscountInPercentage;
        const final = total - (total * discount) / 100;
        return `${final} `;
      },
    },
  ];

  return (
    <>
      <Grid2
        container
        spacing={1}
        sx={{
          paddingX: "5px",
          paddingTop: "5px",
          paddingBottom: "50px",
          maxHeight: "calc(100vh - 150px)",
          overflowY: "auto",
        }}
      >
        <MenuBar
          showEdit={true}
          onEdit={() => onEditPlan(planData)}
          editTooltip="Edit Plan"
          editLabel="Edit Plan"
        />
        {showSpinner && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(216, 214, 214, 0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1301,
            }}
          >
            {showLoadingImage()}
          </div>
        )}
        <Grid2 container size={12} sx={{ paddingX: "5px" }}>
          <Grid2 container size={12} sx={{ paddingX: "5px" }}>
            {isSmallScreen ? (
              // Mobile view layout using cards
              <Grid2 container size={12} sx={{ px: 1 }}>
                {renderPatientDetailsCard()}
                {renderVisitDetailsCard()}
                {renderPrimaryServiceCard()}
                {renderBillInfoCard()}
                {renderAllVisitsCard()}
              </Grid2>
            ) : (
              // Desktop view layout - unchanged
              <Grid2 container size={12}>
                <Grid2 container size={12}>
                  {/* Patient's Details Section - Single Row */}
                  <Grid2 size={12}>
                    <Card
                      className="outerCard"
                      variant="outlined"
                      sx={{
                        padding: "4px",

                        pointerEvents: showLoading ? "none" : "auto",
                        opacity: showLoading ? 0.6 : 1,
                        width: "100%",
                      }}
                    >
                      <Grid2 container size={12}>
                        <Grid2 size={12}>
                          <Typography variant="body1">
                            Patient's Details
                          </Typography>
                          <Grid2
                            container
                            size={12}
                            sx={{ alignItems: "center" }}
                          >
                            {/* Patient Name */}
                            <Grid2 size={2}>
                              {/* <Tooltip
                                placement="bottom-start"
                                arrow
                                title="Patient Name"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Person fontSize="small" />
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      onViewPatientDetails &&
                                      onViewPatientDetails({
                                        id: planData?.visits?.[0]?.patientId,
                                        firstName:
                                          planData?.visits?.[0]
                                            ?.patientFirstName,
                                        lastName:
                                          planData?.visits?.[0]
                                            ?.patientLastName,
                                      })
                                    }
                                  >
                                    {planData?.visits?.[0]?.patientFirstName}{" "}
                                    {planData?.visits?.[0]?.patientLastName}
                                  </span>
                                </Box>
                              </Tooltip> */}
                              <Tooltip
                                placement="bottom-start"
                                arrow
                                title="Patient Name"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Person fontSize="small" />
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      onViewPatientDetails &&
                                      onViewPatientDetails({
                                        id: planData?.patientId,
                                        firstName:
                                          planData?.visits?.[0]
                                            ?.patientFirstName,
                                        lastName:
                                          planData?.visits?.[0]
                                            ?.patientLastName,
                                      })
                                    }
                                  >
                                    {planData?.visits?.[0]?.patientFirstName}{" "}
                                    {planData?.visits?.[0]?.patientLastName}
                                  </span>
                                </Box>
                              </Tooltip>
                            </Grid2>

                            {/* MRN */}
                            <Grid2 size={1.7}>
                              <Tooltip
                                placement="bottom-start"
                                arrow
                                title="Patient MRN No."
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Badge fontSize="small" />
                                  <Typography
                                    variant="body2"
                                    sx={{ whiteSpace: "nowrap" }}
                                  >
                                    {planData?.visits?.[0]?.patientMRN || "N/A"}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid2>

                            {/* Age */}
                            <Grid2 size={1.6}>
                              <Tooltip
                                placement="bottom-start"
                                arrow
                                title="Age"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Cake fontSize="small" />
                                  <Typography
                                    variant="body2"
                                    sx={{ whiteSpace: "nowrap" }}
                                  >
                                    {formatAge(
                                      planData?.visits?.[0]?.patientAgeInYears,
                                    )}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid2>

                            {/* Gender */}
                            <Grid2 size={1.5}>
                              <Tooltip
                                placement="bottom-start"
                                arrow
                                title="Gender"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Wc fontSize="small" />
                                  <Typography
                                    variant="body2"
                                    sx={{ whiteSpace: "nowrap" }}
                                  >
                                    {planData?.visits?.[0]?.patientGender ||
                                      "N/A"}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid2>

                            {/* Contact */}
                            <Grid2 size={1.8}>
                              <Tooltip
                                placement="bottom-start"
                                arrow
                                title="Mobile"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Phone fontSize="small" />
                                  <Typography
                                    variant="body2"
                                    sx={{ whiteSpace: "nowrap" }}
                                  >
                                    {planData?.visits?.[0]?.patientMobileNo ||
                                      "N/A"}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid2>

                            {/* Email */}
                            <Grid2 size={2.4}>
                              <Tooltip
                                placement="bottom-start"
                                arrow
                                title="Email"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Email fontSize="small" />
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {planData?.visits?.[0]?.patientEmailId ||
                                      "N/A"}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid2>

                            {/* Patient Photo */}
                            <Grid2 size={1}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  height: "100%",
                                  justifyContent: "center",
                                  mt: -2,
                                }}
                              >
                                <img
                                  src={
                                    planData?.patient?.photo
                                      ? planData?.patient?.photo
                                      : planData?.visits?.[0]?.patientGender ===
                                          "Male"
                                        ? "./placeholder-image-male-gender.webp"
                                        : "./placeholder-image-female-gender.webp"
                                  }
                                  className="border rounded p-0"
                                  alt="PatientPhoto"
                                  width="50"
                                  height="50"
                                  style={{ objectFit: "cover" }}
                                />
                              </Box>
                            </Grid2>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Card>
                  </Grid2>
                </Grid2>

                {/*plan detail */}
                <Grid2 size={12}>
                  <Card
                    className="outerCard"
                    variant="outlined"
                    sx={{
                      padding: "4px",

                      pointerEvents: showLoading ? "none" : "auto",
                      opacity: showLoading ? 0.6 : 1,
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12} spacing={1}>
                      <Typography variant="body1">Plan's Details</Typography>
                      <Grid2 container size={12}>
                        {/* plan displayId */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Display Id"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Badge fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {planData.displayId}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>

                        {/* plan name */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Plan Name"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <DnsIcon fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {planData.name}{" "}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>

                        {/* currentVisitType */}
                        <Grid2 size={2}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Visit Type"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <LocalHospitalIcon fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {planData?.visits?.[0]?.currentVisitType}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>

                        {/* referredBy */}
                        <Grid2 size={2}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Referred By "
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <PersonAddIcon fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {planData?.visits?.[0]?.referredBy}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                        {/* plan status */}
                        <Grid2 size={2}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Status"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <ScheduleIcon fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {planData.status || "N/A"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                      </Grid2>
                      <Grid2 container size={12}>
                        {/* plan createdByUserName */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Created By"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Person fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100%",
                                }}
                              >
                                {planData.createdByUserName || "N/A"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                        {/*plan date and time */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Date & Time"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <CalendarMonthIcon fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100%",
                                }}
                              >
                                {convertUTCToTimeZoneDateTimeString(
                                  planData.createdOn,
                                  auth?.selectedFacility?.timeZone,
                                )}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                        {/* plan notes */}
                        <Grid2 size={3}>
                          <Tooltip placement="bottom-start" arrow title="Notes">
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <NotesIcon fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100%",
                                }}
                              >
                                {planData.schedulingNotes || "N/A"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Card>
                </Grid2>

                {/* Primary Service Scheduled With  */}
                <Grid2 size={12}>
                  <Card
                    className="outerCard"
                    variant="outlined"
                    sx={{
                      padding: "4px",

                      pointerEvents: showLoading ? "none" : "auto",
                      opacity: showLoading ? 0.6 : 1,
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12} spacing={1}>
                      <Typography variant="body1">
                        Primary Service Scheduled With
                      </Typography>
                      <Grid2 container size={12}>
                        {/* plan physicianName */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Physician Name"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Person fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {`${planData?.physicianName || ""} `.trim()}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>

                        {/* physicianEmail */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Physician Email"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Email fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {planData.physicianEmail || "N/A"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>

                        {/* physicianMobileNo */}
                        <Grid2 size={2}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Physician Mobile No."
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Phone fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {planData.physicianMobileNo || "N/A"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Card>
                </Grid2>

                {/* bill info  */}
                <Grid2 size={12}>
                  <Card
                    className="outerCard"
                    variant="outlined"
                    sx={{
                      padding: "4px",
                      pointerEvents: showLoading ? "none" : "auto",
                      opacity: showLoading ? 0.6 : 1,
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12} spacing={1}>
                      <Typography variant="body1">
                        Billing Information
                      </Typography>
                      <Grid2 container size={12}>
                        {/* plan bill id */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Bill ID"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Badge fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    onEditBill &&
                                    onEditBill({
                                      id: billDetails?.id,
                                      displayId: billDetails?.displayId,
                                      patientName: `${planData?.patientFirstName} ${planData?.patientLastName}`,
                                    })
                                  }
                                >
                                  {billDetails?.displayId}
                                </span>
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>

                        {/* totalAmount */}
                        <Grid2 size={3}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Total Amount"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              {" "}
                              <RequestQuoteIcon fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {`Rs ${(
                                  billDetails?.totalAmount +
                                  (parseFloat(billDetails?.advanceAmount) || 0)
                                ).toFixed(2)}`}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>

                        {/* paidAmount */}
                        <Grid2 size={2}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Paid Amount"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <PaidIcon fontSize="small" />

                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {`Rs ${billDetails?.paidAmount?.toFixed(2)}`}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                        {/* refundedAmount */}
                        <Grid2 size={2}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Refunded Amount"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <UndoIcon fontSize="small" />

                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {`Rs ${billDetails?.refundedAmount?.toFixed(
                                  2,
                                )}`}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                        {/* balanceAmount */}
                        <Grid2 size={2}>
                          <Tooltip
                            placement="bottom-start"
                            arrow
                            title="Balance Amount"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <AccountBalanceWalletIcon fontSize="small" />

                              <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {`Rs ${billDetails?.balanceAmount?.toFixed(2)}`}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Card>
                </Grid2>
                {/* visit datagrid */}
                <DataGrid
                  localeText={{
                    noRowsLabel: "There are no visit to display.",
                  }}
                  loading={showSpinner}
                  slotProps={{
                    loadingOverlay: {
                      variant: "skeleton",
                      noRowsVariant: "skeleton",
                    },
                  }}
                  initialState={{
                    density: "compact",
                    pagination: {
                      paginationModel: { pageSize: 20 }, // Default page size
                    },
                  }}
                  sx={{
                    width: "100%",
                    maxHeight: "500px",
                    "& .MuiTablePagination-toolbar": {
                      minHeight: "unset",
                      alignItems: "center",
                      paddingTop: "0 !important",
                      paddingBottom: "0 !important",
                    },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                      {
                        margin: 0,
                      },
                  }}
                  rows={planData?.visits}
                  columns={columns}
                  pageSizeOptions={[5, 10, 15, 20]}
                  rowsPerPageOptions={[5, 10, 15, 20]}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                />
              </Grid2>
            )}
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
};

export default PlanDetails;
